import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withRouter } from 'react-router-dom';
import { Badge, Tooltip } from 'antd';

export default withRouter(function CLExclamationIcon() {

  return (
    <span style={{ float: 'right', height: '24.66px', width: '24.25px' }}> 
      <Tooltip placement="topRight" title="Project has Exception Forms" overlayStyle={{maxWidth: 'max-content'}}>
          <FontAwesomeIcon
            id={'excmtnIcon'}
            icon={faExclamationTriangle}
            pull={'left'}
            size='lg'
            style={{ color: '#dc3545' }}

          />
          </Tooltip>   
    </span>
  );
});
